import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { HotSaleItem, HotSaleContainer } from '../../../components_renew/Mall/HotSale'
import { requestHotSaleData, setProductDetailsData } from '../../../actions/mallAction'

@withRouter
@connect(state => {
  return state.mallHotSale
})
class HotSale extends React.PureComponent {
  componentDidMount () {
    if (!(this.props.data.length > 0)) {
      this.props.dispatch(requestHotSaleData())
    }
  }

  render () {
    let { data } = this.props
    return <HotSaleContainer>
      {data.map(item => <HotSaleItem key={item.id}
        onClick={this.toProductDetails.bind(this, item)}
        src={item['productPic']}
        price={item['currentPrice']}
      />)}
    </HotSaleContainer>
  }

  toProductDetails = (item) => {
    this.props.dispatch(setProductDetailsData(item))
    this.props.history.push(`${window.PATH.MALL_PRODUCT_DETAILS}/${item['id']}`)
  }
}

export { HotSale }
